import React, { useState, useEffect, useMemo } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { wsGetAll, wsFindBy } from 'services/WService';
import Modal from 'components/Tvendo/Common/ModalBase';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import LayerCombo from 'components/Tvendo/Common/LayerCombo';
import useLayerContext from 'contexts/layerContext';

const defaultBureau = { id: null, base_zone_id: '', description: '' };

export default function ModalCustomerPortfolioB(props) {
  const customerPortfolioB = props.model;
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);
  const {
    selectedLayer,
    setSelectedLayer,
    divitions,
    selectedDivition,
    setSelectedDivition,
  } = useLayerContext();

  const [bureauSelect, setBureauSelect] = useState(defaultBureau);

  //seller (vendedor)
  const [sellers, setSellers] = useState([]);
  const [bureaus, setBureaus] = useState([]);
  const [customerPs, setCustomerPs] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [visitDays, setVisitDays] = useState([]);

  function handleChange(field, value) {
    if (field === 'base_seller_id') {
      const { base_bureau_id, base_customer_portfolio_id, base_route_id, ...rest } = dataChanging;
      setDataChanging({ ...rest, [field]: value });
      setBureaus([]);
      setCustomerPs([]);
      setRoutes([]);
      setBureauSelect(defaultBureau);
      return;
    }

    setDataChanging({ ...dataChanging, [field]: value });
  }

  async function listSeller() {
    let response = await wsFindBy('base/seller', { seller_type: 'S' });
    if (response.success) setSellers(response.data);
  }

  async function listBureaus(idSeller) {
    let response = await wsGetAll(`base/seller/${idSeller}/valid-bureaus`);
    if (response.success) {
      if (customerPortfolioB.id) {
        const select = response.data.find((item) => item.id == dataChanging.base_bureau_id);
        setBureauSelect(select);
        listCustomerPs(select?.base_zone_id);
        listRoutes(select?.base_zone_id);
      }
      setBureaus(response.data);
    }
  }

  async function listCustomerPs(zoneId) {
    let response = await wsFindBy(
      'base/customer-portfolio',
      zoneId != null ? { base_zone_id: zoneId } : null,
    );
    if (response.success) setCustomerPs(response.data);
  }

  async function listRoutes(zoneId) {
    let response = await wsFindBy('base/route', zoneId != null ? { base_zone_id: zoneId } : null);
    if (response.success) setRoutes(response.data);
  }

  async function listVisitDays() {
    let response = await wsGetAll('base/visit-day');
    if (response.success) setVisitDays(response.data);
  }

  const filteredRoutes = useMemo(() => {
    if (routes.length === 0) return routes;
    if (selectedLayer === undefined) return routes;
    return routes.filter((route) => parseInt(route.base_layer_id) === selectedLayer.id);
  }, [selectedLayer, routes]);

  useEffect(() => {
    if (customerPortfolioB.open) {
      if (!customerPortfolioB.id) listSeller();
      listVisitDays();
      setDataChanging(customerPortfolioB);
    }
  }, [customerPortfolioB.open]);

  useEffect(() => {
    if (dataChanging.base_seller_id) {
      listBureaus(dataChanging.base_seller_id);
    }
    if (customerPortfolioB.id) {
      listBureaus(customerPortfolioB.base_seller_id);
    }
  }, [customerPortfolioB.id, dataChanging.base_seller_id]);

  useEffect(() => {
    if (customerPortfolioB.route === undefined) return;
    if (customerPortfolioB.open === false) return;
    let layer = customerPortfolioB.route.layer;
    let divition = divitions.find((divition) => divition.id === parseInt(layer.divition_id));
    setSelectedDivition(divition);
    setTimeout(() => {
      setSelectedLayer(layer);
    });
  }, [customerPortfolioB]);

  return (
    <Modal
      title="Cartera Mesa"
      model={customerPortfolioB}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={{ ...dataChanging, base_layer_id: selectedLayer?.id }}
      setDataChanging={setDataChanging}
      entity="base/customer-portfolio-bureau"
      state
    >
      {customerPortfolioB.id ? (
        <h5 style={{ fontSize: '16px', fontWeight: '400', borderBottom: '1px solid #949494' }}>
          {customerPortfolioB.SlpName}
        </h5>
      ) : (
        <Autocomplete
          disableClearable
          options={sellers}
          getOptionLabel={(option) => option.SlpName}
          renderInput={(params) => (
            <TextField {...params} label="Vendedor" margin="normal" required />
          )}
          onChange={(e, item) => handleChange('base_seller_id', item.id)}
        />
      )}

      {!dataChanging.base_seller_id && !customerPortfolioB.id ? (
        <p style={{ color: '#2d9acf', margin: '0' }}>Elija vendedor para más opciones</p>
      ) : undefined}

      {bureaus.length > 0 || bureauSelect?.id ? (
        <Autocomplete
          key={dataChanging.base_seller_id}
          disableClearable
          options={bureaus}
          getOptionLabel={(option) => option.description}
          defaultValue={bureauSelect || undefined}
          renderInput={(params) => <TextField {...params} label="Mesa" margin="normal" required />}
          onChange={(e, item) => {
            delete dataChanging.basebase_customer_portfolio_id;
            delete dataChanging.base_route_id;
            setDataChanging({
              ...dataChanging,
              base_bureau_id: item.id,
              base_zone_id: item.base_zone_id,
            });
            setBureauSelect(item);
            if (!customerPortfolioB.id) {
              listCustomerPs(item.base_zone_id);
              listRoutes(item.base_zone_id);
            }
          }}
        />
      ) : undefined}

      {!dataChanging.base_bureau_id && dataChanging.base_seller_id ? (
        <p style={{ color: '#2d9acf', margin: '0' }}>Elija mesa para más opciones</p>
      ) : undefined}

      <LayerCombo
        onChange={(_, item) => {
          if (item === null) return;
          setDataChanging((data) => ({
            ...data,
            base_layer_id: item.id,
            base_route_id: -1,
          }));
        }}
      />

      {customerPs.length > 0 ? (
        <Autocomplete
          disableClearable
          options={customerPs.filter((cartera) => cartera.divition.id === selectedDivition?.id)}
          getOptionLabel={(option) => option.description}
          value={
            customerPs.find((item) => item.id == dataChanging.base_customer_portfolio_id) || null
          }
          renderInput={(params) => (
            <TextField {...params} label="Cartera" margin="normal" required />
          )}
          onChange={(e, item) => {
            if (!!item) {
              setSelectedDivition(item.divition);
              console.log(item);
            }
            handleChange('base_customer_portfolio_id', item.id);
          }}
        />
      ) : undefined}

      <Autocomplete
        disableClearable
        options={filteredRoutes}
        getOptionLabel={(option) => option.description}
        value={routes.find((item) => item.id === parseInt(dataChanging.base_route_id)) || null}
        renderInput={(params) => <TextField {...params} label="Ruta" margin="normal" required />}
        onChange={(e, item) => handleChange('base_route_id', item.id)}
      />

      {dataChanging.base_bureau_id && (customerPs.length === 0 || routes.length === 0) ? (
        <p style={{ color: 'red', margin: '0' }}>La mesa no tiene carteras o rutas</p>
      ) : undefined}

      {visitDays.length > 0 ? (
        <Autocomplete
          disableClearable
          options={visitDays}
          getOptionLabel={(option) => option.description}
          defaultValue={
            visitDays.find((item) => item.id == customerPortfolioB.base_visit_day_id) || undefined
          }
          renderInput={(params) => (
            <TextField {...params} label="Día visita" margin="normal" required />
          )}
          onChange={(e, item) => {
            if (!!item) {
              return handleChange('base_visit_day_id', item.id);
            }
            handleChange('base_visit_day_id', null);
          }}
        />
      ) : undefined}

      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Frecuencia</InputLabel>
        <Select
          value={dataChanging.frequency || 'W'}
          required
          inputProps={{
            name: 'frequency',
          }}
          onChange={(e) => {
            let value = e.target.value;
            handleChange('frequency', value);
          }}
        >
          <MenuItem value="W">Semanal</MenuItem>
          <MenuItem value="B">Quincenal</MenuItem> {/* Se actualiza todos los lunes */}
        </Select>
      </FormControl>
    </Modal>
  );
}
